import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import en from '../../../../lang/en-us';
import { SubmitButton } from '../../../../lib/Button';
const { dashboard } = en;
import { UploadFile } from '../../../../lib/UploadFile.tsx';
import { RootStateType } from '../../../../redux-store/reducers';
import { ConsolidateTableRowType } from '../ConsolidationFolios/types';
import { BANK_ACCOUNT_DETAILS, BANK_ACCOUNT_TYPE } from './index';
import { sendPhoneOTP, onSaveImageData } from '../../../../redux-store/actions/nct';
import { OTP_ACTIONS, TaxStatusRIArray, GENERAL } from '../../../../utils/constants';
import { ActionHeader, FaqLink } from '..';
import { ImageSaveType } from '../../../../redux-store/types/nct';

const NEW_TAX_STATUS = {
    RI: 'Resident Indian',
    NRI: 'NRI Non Repatriable',
};

// const RI_ALLOW_TYPES = {
//     NRO: 'SAVING',
//     NRE: 'SAVING',
// };

// const NRI_ALLOW_TYPES = {
//     SAVING: 'NRO',
//     NRE: 'NRO',
// };

const getTaxStatusOptions = (taxCode: string) => {
    switch (taxCode) {
        case '01':
            return [{ key: '24', value: NEW_TAX_STATUS.NRI }];

        case '24':
            return [{ key: '01', value: NEW_TAX_STATUS.RI }];

        case '21':
            return [
                { key: '01', value: NEW_TAX_STATUS.RI },
                { key: '24', value: NEW_TAX_STATUS.NRI },
            ];

        default: {
            return [];
        }
    }
};

function ChangeTaxUpload(props: any) {
    const {
        statusChange = null,
        targetFunds = [],
    }: { statusChange: string | null; targetFunds: ConsolidateTableRowType[] } =
        props.location.state || {};

    const [image, setImage] = useState({
        name: 'NewCheque',
        format: '',
        content: '',
    });

    const [newTaxStatus, setNewTaxStatus] = useState<string>('');
    const [taxStatusOptions, setTaxStatusOptions] = useState<{ key: string; value: string }[]>([]);

    useEffect(() => {
        if (!statusChange || !targetFunds.length) {
            props.history.push('/');
            return;
        }
    }, []);

    useEffect(() => {
        const currentTaxStatus = targetFunds[0]?.taxStatus || '';
        const newTax = currentTaxStatus === '01' ? '24' : '01';
        setNewTaxStatus(newTax);
        setTaxStatusOptions(getTaxStatusOptions(currentTaxStatus));
    }, [targetFunds]);

    const handleSubmit = async () => {
        if (statusChange === BANK_ACCOUNT_DETAILS) {
            props.history.replace('tax-bank-details', { targetFunds, newTaxStatus, statusChange });
            return;
        }
        const data = targetFunds.map((_ele: ConsolidateTableRowType, index: number) => ({
            amc: _ele.amc,
            folio: _ele.folio,
            newBank: {
                accountType: newTaxStatus === '01' ? 'SAVINGS' : 'NRO',
                ifsc: '',
                accountNo: '',
                name: '',
            },
            newTaxStatus,
            source: statusChange === BANK_ACCOUNT_TYPE ? 'a' : 'b',
        }));
        const { pan, pekrn, mobile } = props;
        try {
            let res = await props.sendPhoneOTP({
                mobile,
                pan,
                pekrn,
                action: OTP_ACTIONS.changeTaxStatus,
            });
            props.history.replace('change-tax-otp', {
                data,
                images: [image],
                mobile: props.mobile,
                pan: props.pan,
                ...(res || {}).body,
            });
        } catch (err: any) {
            alert(err);
        }
    };

    // save image in store
    useEffect(() => {
        return () => {
            const imageInfo: ImageSaveType = {
                data: [image],
                type: 'CHANGE_TAX_STATUS',
            };
            props.onSaveImageData(imageInfo);
        };
    }, [image]);

    return (
        <div className="curved-bg">
            <ActionHeader
                subHeader={dashboard.ChangeTaxStatus.ChangeTaxStatusHeadingSpan}
                header={dashboard.ChangeTaxStatus.ChangeTaxStatusHeading}
            />
            <div className="curved-bg-content curved-bg-table-outer">
                <div className="curved-bg-content-table">
                    <div
                        className="curved-table-content change-tax-upload-content"
                        tabIndex={0}
                        aria-label="Change tax status form"
                    >
                        <div className="change-tax-upload">
                            <FormControl variant="outlined">
                                <InputLabel id="new-status-type-label">
                                    {dashboard.ChangeTaxStatus.newStatusType}
                                </InputLabel>
                                <Select
                                    labelId="new-status-type-label"
                                    id="new-status-type"
                                    value={newTaxStatus}
                                    readOnly={taxStatusOptions.length === 1}
                                    onChange={(e: any) => setNewTaxStatus(e.target.value)}
                                >
                                    {taxStatusOptions.map(
                                        (_ele: { key: string; value: string }) => (
                                            <MenuItem value={_ele.key} key={_ele.key}>
                                                {_ele.value}
                                            </MenuItem>
                                        ),
                                    )}
                                </Select>
                            </FormControl>
                            <FormControl variant="outlined">
                                <InputLabel id="new-account-type-label">
                                    {dashboard.ChangeTaxStatus.newAccountType}
                                </InputLabel>
                                <Select
                                    labelId="new-account-type-label"
                                    id="new-account-type"
                                    value={newTaxStatus}
                                    readOnly
                                >
                                    <MenuItem value={'01'}>SAVINGS</MenuItem>
                                    <MenuItem value={'24'}>NRO</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div className="curved-bg-content-inner-bottom">
                            {statusChange === BANK_ACCOUNT_TYPE && (
                                <>
                                    <h4>{dashboard.ChangeTaxStatus.uploadDocuments}</h4>
                                    <p>{dashboard.ChangeTaxStatus.uploadDocumentsInfo}</p>
                                    <div className="change-bank-upload">
                                        <p>{dashboard.ChangeTaxStatus.newProof}</p>
                                        <UploadFile
                                            onImageSelected={(value, format) =>
                                                setImage({
                                                    ...image,
                                                    format: format,
                                                    content: value,
                                                })
                                            }
                                        />
                                    </div>
                                </>
                            )}
                            <FaqLink section={GENERAL} history={props.history} />
                            <SubmitButton
                                label={dashboard.ChangeTaxStatus.buttonText}
                                onClick={handleSubmit}
                                className="customBtn"
                                disabled={
                                    statusChange === BANK_ACCOUNT_TYPE &&
                                    !Object.values(image).every((_ele) => !!_ele)
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/* <NoteModals
                showModal={true}
                heading={dashboard.ChangeTaxStatus.noteModals.heading}
                info={dashboard.ChangeTaxStatus.noteModals.info}
                proceedBtn={dashboard.ChangeTaxStatus.noteModals.proceedText}
                cancelBtn={dashboard.ChangeTaxStatus.noteModals.cancelText}
            /> */}
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    sendPhoneOTP,
    onSaveImageData,
})(ChangeTaxUpload);
